// extracted by mini-css-extract-plugin
export default {"logo-text":"footer_logo-text__Kbl9m"};